import { safeJSONParse } from "../../../utils";
import { getLanguageKeyByDisplayName } from "../../../utils/quineLanguage";
import { BOnboardingInfo, IOnboardingInfo } from "./types";

export const adaptOnboardingInfo = ({
  myLanguages,
  myTopics,
  lookingForPartTimeOpportunities,
  about,
  jobRole,
  profileEmail,
  displayName,
  angelLink,
  stackOverflowLink,
  portfolioOrder,
  cvId,
  devToId,
  devToUsername,
  hasSeenWidgetsTab,
  isViewerFollowing,
  registeredAt,
  emailVerified,
  ...rest
}: BOnboardingInfo): IOnboardingInfo => ({
  ...rest,
  cvId: cvId || null,
  emailVerified: !!emailVerified,
  lookingForPartTimeOpportunities: lookingForPartTimeOpportunities ?? false,
  angelLink: angelLink || null,
  stackOverflowLink: stackOverflowLink || null,
  about: about || null,
  displayName: displayName || "",
  headline: jobRole || "",
  profileEmail: profileEmail || "",
  myLanguages: myLanguages.map((language) => ({
    id: language.name,
    name: language.name,
    key: getLanguageKeyByDisplayName(language.name),
    isSelected: language.isSelected,
  })),
  myTopics: myTopics.map((topic) => ({
    id: topic,
    name: topic,
    isSelected: true,
  })),
  portfolioOrder: portfolioOrder ? safeJSONParse(portfolioOrder) || null : null,
  devToId: devToId || null,
  devToUsername: devToUsername || null,
  hasSeenWidgetsTab: hasSeenWidgetsTab ?? true,
  isViewerFollowing: !!isViewerFollowing,
  registeredAt: registeredAt || "",
});
